import { forwardRef } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

export const DirectionalButtonLeft = forwardRef(({ prevTile, hidden }, ref) => {
  const { t } = useTranslation('tileView');

  return (
    <ArrowContainerLeft>
      <Arrow
        aria-label={t('previousTile')}
        onClick={prevTile}
        id="prev_tile"
        ref={ref}
        $hidden={hidden}
      >
        <i className="fa-regular fa-arrow-left fa-xl" />
      </Arrow>
    </ArrowContainerLeft>
  );
});

export const DirectionalButtonRight = forwardRef(
  ({ nextTile, hidden }, ref) => {
    const { t } = useTranslation('tileView');

    return (
      <ArrowContainerRight>
        <Arrow
          aria-label={t('nextTile')}
          onClick={nextTile}
          id="next_tile"
          ref={ref}
          $hidden={hidden}
        >
          <i className="fa-regular fa-arrow-right fa-xl" />
        </Arrow>
      </ArrowContainerRight>
    );
  },
);

DirectionalButtonRight.displayName = 'DirectionalButtonRight';

DirectionalButtonLeft.displayName = 'DirectionalButtonLeft';

export const ArrowWrapper = styled.div`
  padding: ${props =>
    props.$hasSidePadding ? '0px 24px 26px;' : '0px 0px 26px;'};
  display: flex;
  justify-content: space-between;
  margin: auto;
`;

const Arrow = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border: 1px solid rgba(232, 232, 232, 0.64);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
  width: 48px;
  height: 48px;
  border-radius: 5px;
  padding: 0;

  ${({ $hidden }) => $hidden && 'visibility: hidden;'}

  &:focus,
  &:hover {
    background: white;
  }

  &:disabled {
    background: ${themeGet('colors.black.20')};
    border: none;

    &:hover {
      background: ${themeGet('colors.black.20')};
    }
  }

  i {
    color: ${themeGet('colors.black.60')};
  }

  ${themeGet('mediaQueries.forMediumUp')} {
    border-radius: 8px;
  }
`;

const BaseWrapper = styled.div`
  img {
    width: 16px;
  }

  ${themeGet('mediaQueries.forMediumUp')} {
    width: 40px;

    img {
      width: initial;
    }
  }
`;

const ArrowContainerLeft = styled(BaseWrapper)`
  left: 25px;

  ${themeGet('mediaQueries.forMediumUp')} {
    left: -70px;
  }
`;

const ArrowContainerRight = styled(BaseWrapper)`
  right: 50px;

  ${themeGet('mediaQueries.forMediumUp')} {
    right: -70px;
  }
`;
